module.exports = __webpack_public_path__ + "img/background960w1.b0bffc51.png";